// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export { default } from '/home/runner/work/GPT-Vis/GPT-Vis/node_modules/.pnpm/dumi@2.4.21_@babel+core@7.28.6_@swc+helpers@0.5.15_@types+node@25.0.10_@types+react@18.3.27_e_33xh2m4ldb5frcfwx6avi2czjq/node_modules/dumi/theme-default/slots/Loading/index.js';
